import {Component, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {filter, Observable} from "rxjs";
import {View} from "../../../../shared/store/view/types";
import {BreadcrumbService} from "xng-breadcrumb";
import {ViewService} from "../../../../shared/store/view/views.service";

@UntilDestroy()
@Component({
    selector: 'app-human-resources-dashboard',
    templateUrl: './human-resources-dashboard.component.html',
    styleUrls: ['./human-resources-dashboard.component.scss'],
    standalone: false
})
export class HumanResourcesDashboardComponent implements OnInit{
  view$: Observable<View>;

  constructor(private readonly breadcrumbService:BreadcrumbService,
              private readonly viewService:ViewService
  ) {
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.view$.pipe(
      untilDestroyed(this),
      filter((x) => !!x)
    ).subscribe((x) => {
      this.breadcrumbService.set('@humanResourcesDashboard', x.title)
    });
  }

}
